const LoadingBoombox = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128" fill="none">
    <path
      fill="#2259FF"
      d="m45.646 35.658-6.394-.01-.007 4.968 6.393.01.008-4.968Z"
    />
    <mask
      id="b"
      width={7}
      height={6}
      x={39}
      y={35}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}>
      <path
        fill="#fff"
        d="m45.646 35.658-6.394-.01-.007 4.968 6.393.01.008-4.968Z"
      />
    </mask>
    <g mask="url(#b)">
      <path
        fill="#FCFCFC"
        d="m47.532 45.699-9.341-.018-.078-8.042 9.327.019.092 8.04Z"
      />
    </g>
    <path
      fill="#2259FF"
      d="m53.707 35.674-6.394-.01-.008 4.968 6.394.01.008-4.968Z"
    />
    <mask
      id="c"
      width={7}
      height={6}
      x={47}
      y={35}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}>
      <path
        fill="#fff"
        d="m53.707 35.674-6.394-.01-.008 4.968 6.394.01.008-4.968Z"
      />
    </mask>
    <g mask="url(#c)">
      <path
        fill="#FCFCFC"
        d="m55.569 45.708-9.325-.004-.08-8.057 9.327.019.078 8.042Z"
      />
    </g>
    <path
      fill="#2259FF"
      d="m61.752 35.678-6.394-.01-.007 4.968 6.393.01.008-4.968Z"
    />
    <mask
      id="d"
      width={7}
      height={6}
      x={55}
      y={35}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}>
      <path
        fill="#fff"
        d="m61.752 35.678-6.394-.01-.007 4.968 6.393.01.008-4.968Z"
      />
    </mask>
    <g mask="url(#d)">
      <path
        fill="#FCFCFC"
        d="m63.622 45.73-9.327-.018-.092-8.04 9.34.002.079 8.057Z"
      />
    </g>
    <path
      fill="#2259FF"
      d="m69.797 35.695-6.393-.01-.008 4.968 6.393.01.008-4.968Z"
    />
    <mask
      id="e"
      width={7}
      height={6}
      x={63}
      y={35}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}>
      <path
        fill="#fff"
        d="m69.797 35.695-6.393-.01-.008 4.968 6.393.01.008-4.968Z"
      />
    </mask>
    <g mask="url(#e)">
      <path
        fill="#FCFCFC"
        d="m71.673 45.739-9.34-.017-.079-8.043 9.341.018.078 8.042Z"
      />
    </g>
    <path
      fill="#2259FF"
      d="m77.844 35.713-6.394-.01-.008 4.968 6.394.01.008-4.968Z"
    />
    <mask
      id="f"
      width={7}
      height={6}
      x={71}
      y={35}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}>
      <path
        fill="#fff"
        d="m77.844 35.713-6.394-.01-.008 4.968 6.394.01.008-4.968Z"
      />
    </mask>
    <g mask="url(#f)">
      <path
        fill="#FCFCFC"
        d="m79.724 45.747-9.34-.003-.079-8.056 9.327.018.092 8.041Z"
      />
    </g>
    <path
      fill="#2259FF"
      d="m85.903 35.715-6.394-.01-.007 4.968 6.393.01.008-4.968Z"
    />
    <mask
      id="g"
      width={7}
      height={6}
      x={79}
      y={35}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}>
      <path
        fill="#fff"
        d="m85.903 35.715-6.394-.01-.007 4.968 6.393.01.008-4.968Z"
      />
    </mask>
    <g mask="url(#g)">
      <path
        fill="#FCFCFC"
        d="m87.763 45.77-9.327-.018-.078-8.042 9.325.004.08 8.057Z"
      />
    </g>
    <path
      fill="#FCFCFC"
      d="M115.182 45.177 9.464 44.994a.924.924 0 0 1-.906-.904l.02-14.553a.924.924 0 0 1 .904-.906l105.718.182a.925.925 0 0 1 .906.904l-.02 14.554a.924.924 0 0 1-.904.906ZM10.36 43.19l103.922.17.02-12.76-103.92-.154-.02 12.759-.002-.015Z"
    />
    <path
      className="anim-fill"
      fill="#FF813A"
      d="m113.489 40.5-101.303-.158-.095 60.35 101.304.159.094-60.35Z"
    />
    <path
      fill="#FD81F5"
      d="m113.478 40.495-101.304-.16-.028 17.914 101.304.16.028-17.914Z"
    />
    <path
      fill="#825DC4"
      d="m113.512 58.485-101.431-.17.029-18.044 101.445.168-.029 18.044-.014.002Z"
    />
    <path
      fill="#000"
      d="m113.448 57.249-101.304-.16-.002 1.21 101.304.16.002-1.21ZM76.59 97.203l-28.066-.048c-.114.012-.198-.095-.194-.197l.064-36.726c-.012-.114.095-.198.196-.194l28.066.047c.115-.012.198.095.195.197l-.064 36.726c.012.115-.095.198-.197.195Z"
    />
    <path
      fill="#FD81F5"
      d="m76.626 71.513-28.066-.048c-.114.012-.205-.022-.195-.066l.013-11.31s.094-.068.196-.064l28.066.047c.115-.012.205.022.195.067l-.013 11.31s-.094.067-.196.064Z"
    />
    <path
      fill="#2259FF"
      d="m74.064 79.472-22.58-.036-.022 14.256 22.58.036.022-14.256Z"
    />
    <path
      fill="#825DC4"
      d="m69.761 90.782-3.099-.007-6.792-.01-3.1-.008-2.02 2.95 5.125-.003 6.779.025 5.125-.002-2.018-2.945Z"
    />
    <path
      fill="#000"
      d="M58.884 86.206a1.645 1.645 0 0 1-1.638 1.635c-.911.009-1.626-.727-1.635-1.638-.008-.912.727-1.626 1.639-1.635.91-.009 1.625.727 1.634 1.638ZM69.89 86.222a1.645 1.645 0 0 1-1.638 1.634c-.911.01-1.626-.726-1.634-1.638-.01-.91.726-1.625 1.638-1.634.91-.01 1.625.727 1.634 1.638Z"
    />
    <path
      fill="#00F1A3"
      d="m108.741 27.23-92.318-.144-.008 5.069 92.318.145.008-5.07Z"
    />
    <path
      fill="#00F1A3"
      d="m108.803 32.425-92.451-.144.006-5.314 92.453.157-.006 5.315-.002-.014Z"
    />
    <path
      fill="#fff"
      d="M45.066 83.322c1.945-8.178-3.108-16.385-11.286-18.33-8.178-1.945-16.384 3.108-18.33 11.286-1.945 8.178 3.108 16.384 11.286 18.33 8.178 1.945 16.384-3.108 18.33-11.286Z"
    />
    <path
      fill="#2259FF"
      d="M43.145 81.9c1.167-7.12-3.657-13.836-10.776-15.003-7.118-1.166-13.834 3.658-15.001 10.776-1.167 7.118 3.657 13.835 10.776 15.002 7.118 1.167 13.834-3.658 15.001-10.776Z"
    />
    <path
      fill="#000"
      d="M37.368 73.394c-.188.006-.376.011-.547.029l-.043.004-.018-.027a8.085 8.085 0 0 0-2.87-2.377 8.088 8.088 0 0 0-3.623-.85 8.208 8.208 0 0 0-3.618.844 8.172 8.172 0 0 0-2.878 2.373l-.025.032-.043.004a7.299 7.299 0 0 0-.555-.043h-1.1l-.002 2.056-.043.005c-.537.259-.986.668-1.296 1.164a3.142 3.142 0 0 0-.49 1.673c-.01.595.166 1.17.48 1.673.313.503.76.904 1.293 1.153l.03-.004.005.058a8.287 8.287 0 0 0 2.395 5.844 8.216 8.216 0 0 0 5.816 2.43 8.226 8.226 0 0 0 5.814-2.407 8.262 8.262 0 0 0 2.412-5.843l-.005-.043.043-.004a3.014 3.014 0 0 0 1.298-1.15c.324-.498.48-1.079.49-1.674a3.066 3.066 0 0 0-.48-1.672 3.04 3.04 0 0 0-1.293-1.153l-.032-.025.001-2.056-1.13.002.014-.016Zm-11.457.654a6.007 6.007 0 0 1 1.988-1.338 6.098 6.098 0 0 1 2.354-.465c.811.002 1.61.164 2.353.477a5.946 5.946 0 0 1 1.981 1.356l.065.065-.083.038a7.405 7.405 0 0 0-.894.586l-.043.005-.029.003a7.553 7.553 0 0 0-3.361-.849 7.524 7.524 0 0 0-3.359.831l-.043.005-.029.003a7.451 7.451 0 0 0-.9-.586l-.079-.05.068-.05.01-.03Zm10.312 7.054a6.11 6.11 0 0 1-1.754 4.253 5.912 5.912 0 0 1-4.232 1.748 6.005 6.005 0 0 1-4.226-1.771 6.025 6.025 0 0 1-1.751-4.261l.015-5.229.075.021c1.041.267 2.031 1.423 2.264 1.702a4.963 4.963 0 0 1 1.682-1.074 5.148 5.148 0 0 1 1.961-.351 5.311 5.311 0 0 1 1.962.344c.62.253 1.194.613 1.678 1.083.23-.284 1.21-1.43 2.268-1.7l.086-.01-.017 5.215-.01.03Z"
    />
    <path
      fill="#fff"
      d="M110.194 83.414c1.946-8.178-3.107-16.384-11.285-18.33-8.178-1.945-16.385 3.108-18.33 11.286-1.945 8.178 3.108 16.384 11.286 18.33 8.178 1.945 16.384-3.108 18.329-11.286Z"
    />
    <path
      fill="#2259FF"
      d="M108.279 82.009c1.167-7.118-3.657-13.835-10.775-15.002-7.119-1.167-13.835 3.658-15.002 10.776-1.167 7.118 3.657 13.835 10.776 15.002 7.118 1.166 13.834-3.658 15.001-10.776Z"
    />
    <path
      fill="#000"
      d="M102.493 73.5c-.188.005-.376.01-.548.028l-.043.005-.017-.027a8.082 8.082 0 0 0-2.87-2.377 8.088 8.088 0 0 0-3.623-.85 8.206 8.206 0 0 0-3.618.843 8.17 8.17 0 0 0-2.878 2.373l-.026.032-.043.004a7.302 7.302 0 0 0-.554-.043h-1.1l-.002 2.056-.043.005c-.537.26-.987.668-1.296 1.164a3.143 3.143 0 0 0-.49 1.673c-.01.595.166 1.17.48 1.673.313.503.76.905 1.293 1.153l.029-.003.006.057a8.286 8.286 0 0 0 2.395 5.844 8.216 8.216 0 0 0 5.816 2.43 8.226 8.226 0 0 0 5.813-2.407 8.258 8.258 0 0 0 2.412-5.843l-.004-.043.043-.004a3.013 3.013 0 0 0 1.298-1.15c.324-.498.48-1.079.49-1.673a3.06 3.06 0 0 0-.48-1.673 3.038 3.038 0 0 0-1.294-1.153l-.031-.025.001-2.056-1.129.002.013-.015Zm-11.457.654a6.008 6.008 0 0 1 1.987-1.339 6.097 6.097 0 0 1 2.355-.464c.811.001 1.61.163 2.353.476a5.946 5.946 0 0 1 1.98 1.356l.066.066-.083.037a7.39 7.39 0 0 0-.894.586l-.043.005-.029.003a7.553 7.553 0 0 0-3.361-.849 7.523 7.523 0 0 0-3.36.831l-.042.005-.029.003a7.472 7.472 0 0 0-.901-.586l-.078-.05.067-.05.012-.03Zm10.312 7.053a6.109 6.109 0 0 1-1.754 4.253 5.912 5.912 0 0 1-4.232 1.748 6.005 6.005 0 0 1-4.226-1.771 6.025 6.025 0 0 1-1.751-4.261l.015-5.229.074.021c1.042.267 2.032 1.423 2.264 1.703a4.96 4.96 0 0 1 1.683-1.075 5.146 5.146 0 0 1 1.961-.35 5.311 5.311 0 0 1 1.962.343c.62.254 1.194.613 1.678 1.084.23-.285 1.21-1.43 2.268-1.701l.086-.01-.017 5.215-.011.03ZM105.186 53.525a4.594 4.594 0 1 0-.96-9.137 4.594 4.594 0 0 0 .96 9.137Z"
    />
    <path
      fill="#00F1A3"
      d="M104.698 52.056a3.103 3.103 0 0 1-3.092-3.107c.009-1.71 1.397-3.1 3.107-3.092a3.103 3.103 0 0 1 3.092 3.107c-.009 1.709-1.397 3.1-3.107 3.092Z"
    />
    <path
      fill="#000"
      d="M23.001 53.388a4.593 4.593 0 1 0-.96-9.137 4.593 4.593 0 0 0 .96 9.137Z"
    />
    <path
      fill="#00F1A3"
      d="M22.528 51.918c-1.71-.009-3.1-1.398-3.092-3.107.009-1.71 1.397-3.1 3.107-3.092 1.71.009 3.1 1.397 3.092 3.107-.009 1.71-1.398 3.1-3.107 3.092Z"
    />
    <path
      fill="#000"
      d="M62.134 64.362c-.42.001-.804.2-.946.505l-.036.076-.055-.53-.797-.003-.01 4.316.84-.001.002-1.912.053.096c.148.303.532.509.951.508.811.002 1.437-.657 1.433-1.526-.005-.868-.611-1.543-1.437-1.543l.002.014Zm-.166 2.277a.656.656 0 0 1-.516-.221.748.748 0 0 1-.215-.528.711.711 0 0 1 .22-.53.69.69 0 0 1 .527-.215.705.705 0 0 1 .516.221.748.748 0 0 1 .215.528.711.711 0 0 1-.22.53.69.69 0 0 1-.527.215Zm3.124.8c.624.008 1.26-.277 1.254-.884-.002-.434-.294-.737-.879-.921-.12-.046-.225-.078-.315-.112-.39-.133-.496-.165-.493-.281.002-.116.168-.192.341-.195.129-.014.353.05.387.234l.854-.003c-.029-.547-.547-.927-1.256-.925-.71.002-1.154.455-1.152.889.003.434.293.722.905.89l.193.051c.448.127.612.168.6.328-.013.16-.21.21-.4.201-.303.004-.517-.104-.55-.289l-.84.001c.021.62.523.988 1.377.985l-.025.032Zm8.232-2.27a.556.556 0 0 1 .267.06l.111-.736a.498.498 0 0 0-.316-.111c-.203-.008-.407.115-.601.338l-.039.047-.033-.315-.796-.003-.01 2.94h.84l.005-1.189c.002-.666.21-1.035.587-1.032l-.015.002Zm-4.784-.742-.694.001.008-.884-.84.001-.008.885-.493-.007-.003.797.493.006-.005 2.158.84-.001.004-2.158h.695l.003-.797Zm3.027 1.521c.006-.912-.614-1.571-1.47-1.583-.855-.011-1.468.632-1.476 1.517-.008.884.641 1.554 1.524 1.548.796.003 1.274-.554 1.36-.969l-.732-.082a.859.859 0 0 1-.28.232.756.756 0 0 1-.353.081c-.48-.008-.665-.263-.692-.521l-.003-.029 2.099-.003.007-.204.016.013Zm-2.094-.359-.003-.028c.03-.264.286-.45.633-.458.391.002.603.226.627.455l.003.03h-1.245l-.015.001Zm-10.447-1.175-.06.528-.038-.083c-.15-.318-.517-.51-.951-.508-.825 0-1.437.657-1.447 1.527-.01.87.61 1.529 1.437 1.543.42 0 .79-.199.946-.505l.035-.076.056.53.797.003.009-2.94-.797-.003.013-.016Zm-.897 2.208a.643.643 0 0 1-.405-.131.74.74 0 0 1-.267-.334.737.737 0 0 1 .161-.813.822.822 0 0 1 .384-.2.84.84 0 0 1 .425.042.764.764 0 0 1 .332.27.607.607 0 0 1 .115.407c.011.1-.009.19-.057.281-.048.092-.098.17-.162.25a.732.732 0 0 1-.244.155.652.652 0 0 1-.285.045l.003.028Zm16.091.322-.007-.072c-.003-.029-.02-.041-.035-.054a.198.198 0 0 0-.062-.037c-.014.001-.044-.01-.073-.007l-.172.018-.007.479.1-.01v-.146l.056-.006.09.165.115-.012-.104-.163c.028-.003.054-.035.08-.067.025-.031.037-.061.034-.09l-.015.002Zm-.18.076-.086.01-.002-.16.086-.009.029-.003s.014-.001.03.012c0 0 .001.014.017.027s.003.028.003.028l.003.03c.001.013.001.013-.011.03-.013.015-.015 0-.029.002l-.029.003-.01.03Zm-.005-.462c-.086.009-.186.02-.266.085-.082.052-.131.13-.181.208a.584.584 0 0 0-.029.278c.01.1.063.182.127.247a.444.444 0 0 0 .246.134c.103.018.19.009.272-.029a.485.485 0 0 0 .214-.167.414.414 0 0 0 .073-.269.574.574 0 0 0-.136-.333.439.439 0 0 0-.333-.139l.013-.015Zm.003.854c-.072.007-.148-.028-.21-.065a.32.32 0 0 1-.134-.174.544.544 0 0 1-.023-.215c.022-.075.059-.137.095-.198a.506.506 0 0 1 .192-.107.39.39 0 0 1 .22.02.418.418 0 0 1 .173.141.577.577 0 0 1 .066.21c.01.1-.038.192-.116.273a.443.443 0 0 1-.263.115Zm-17.844-.05.012-4.157h-.84l.001 2.766-1.985-2.774-.854.003-.012 4.157.84-.001-.002-2.766 1.986 2.774.854-.003ZM32.898 46.426l.322-2.032 6.126.008-.321 2.046H37.23l-.942 5.92-2.52-.01.941-5.92h-1.795l-.016-.012ZM41.65 49.386c-.01.45.202.819.811.827.695 0 1.022-.469 1.125-1.146l.74-4.668 2.535.01-.724 4.55c-.39 2.357-1.7 3.523-4.031 3.522-2.158-.005-3.046-1.012-3.035-2.693.002-.261.03-.54.072-.833l.738-4.552 2.535.009-.74 4.668c-.018.103-.035.22-.024.32l-.002-.014ZM54.063 46.533a3.207 3.207 0 0 1-1.686 2.827l1.244 3.025-2.91.002-.784-2.64-.318.005-.418 2.636-2.535-.01 1.278-7.952 3.332.012c1.404-.003 2.8.458 2.799 2.109l-.002-.014Zm-2.578.401c0-.405-.376-.54-.724-.547l-.623-.007-.22 1.356.652.004c.493.006.912-.285.913-.82l.002.014ZM58.07 44.432l1.49 4.39c.059-.542.12-1.07.208-1.6l.446-2.784 2.462.002-1.264 7.952-2.635.002L57.186 48a40.87 40.87 0 0 1-.242 1.835l-.412 2.548-2.462-.001 1.278-7.954 2.737.002-.014.002ZM68.555 44.445l-1.278 7.953-2.535-.009 1.278-7.953 2.52.01.015-.001ZM68.77 46.493l.32-2.047 6.126.008-.32 2.046H73.1l-.941 5.92-2.535-.008.942-5.92H68.77ZM79.71 49.455c-.011.45.201.819.81.827.695 0 1.023-.47 1.125-1.146l.74-4.668 2.535.009-.724 4.55c-.389 2.358-1.7 3.523-4.031 3.522-2.158-.005-3.046-1.012-3.034-2.693.001-.26.03-.538.072-.833l.737-4.551 2.535.009-.74 4.667c-.018.104-.035.221-.024.321l-.002-.014ZM91.937 46.635c-.001 2.187-1.371 3.344-3.427 3.343l-.869.004-.391 2.474-2.535-.009 1.278-7.953 3.332.012c1.434.008 2.62.55 2.614 2.143l-.002-.014Zm-2.577.416c.006-.493-.352-.6-.772-.6h-.406l-.244 1.53.448-.003c.594-.004.966-.319.973-.942l.001.014ZM91.89 51.563c.004-.927.698-1.492 1.595-1.5.652.004 1.19.295 1.191 1.004-.002.942-.696 1.507-1.593 1.514-.651-.004-1.189-.295-1.192-1.018Zm3.79-7.059-1.06 5.194-2.187-.002.611-5.204 2.635-.002.002.014Z"
    />
  </svg>
);
export default LoadingBoombox;
